import { useLanguage } from '@/contexts/LanguageContext';
import { Check, MapPin } from 'lucide-react';
import { Input } from '@/components/ui/input';

export function StepRegionen({ form, setForm, optionen }) {
  const { t } = useLanguage();

  const toggleBl = (name) => {
    setForm(prev => ({
      ...prev,
      bundeslaender: prev.bundeslaender.includes(name)
        ? prev.bundeslaender.filter(i => i !== name)
        : [...prev.bundeslaender, name],
    }));
  };

  const blListe = optionen?.bundeslaender || optionen?.regionen?.DE || [];

  return (
    <div className="space-y-5" data-testid="step-regionen">
      <div className="text-center mb-6">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
          <MapPin className="h-6 w-6 text-primary" />
        </div>
        <h3 className="font-serif text-xl font-bold text-foreground">{t('dlWizard.step3Title')}</h3>
        <p className="text-sm text-muted-foreground mt-1">{t('dlWizard.step3Desc')}</p>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          {t('dlWizard.bundeslaenderLabel')} * <span className="font-normal text-muted-foreground">({form.bundeslaender.length} {t('dlWizard.gewaehlt')})</span>
        </label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="bundeslaender-auswahl">
          {blListe.map((bl, i) => {
            const name = typeof bl === 'object' ? bl.name : bl;
            const selected = form.bundeslaender.includes(name);
            return (
              <button
                key={i}
                onClick={() => toggleBl(name)}
                className={`px-3 py-2.5 text-xs rounded-lg border-2 transition-all text-left ${
                  selected
                    ? 'bg-primary/5 border-primary text-foreground font-medium'
                    : 'bg-white border-warm-200 text-foreground hover:border-primary/40'
                }`}
                data-testid={`bl-${i}`}
              >
                {selected && <Check className="h-3 w-3 mr-1 inline text-primary" />}
                {name}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.einsatzradiusLabel')}</label>
        <p className="text-xs text-muted-foreground mb-2">{t('dlWizard.einsatzradiusDesc')}</p>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="10"
            max="500"
            step="10"
            value={form.einsatzradius_km}
            onChange={(e) => setForm(p => ({ ...p, einsatzradius_km: e.target.value }))}
            placeholder="z.B. 80"
            className="w-32"
            data-testid="input-einsatzradius"
          />
          <span className="text-sm text-muted-foreground">{t('dlWizard.km')}</span>
        </div>
      </div>

      {form.bundeslaender.length === 0 && (
        <p className="text-xs text-amber-600 bg-amber-50 rounded-lg p-3">
          {t('dlWizard.bundeslaenderHinweis')}
        </p>
      )}
    </div>
  );
}
